<template>
  <div class="widget">
    <div @click="toggle = !toggle" title="Toggle Settings" class="toggle">
      <Icon icon="settings" color="eta" style="float: right;" alt="Company & Theme Settings" />
    </div>
    <div v-show="toggle">
      <label aria-label="company-widget-label">Company</label>
      <select
        aria-labelledby="company-widget-label"
        class="form-control"
        name="company"
        @value="company"
        @change="updateCompany"
      >
        <option value="nexcess">Nexcess</option>
        <option value="thermo">Thermo</option>
      </select>
      <hr />
      <label aria-label="theme-widget-label">Theme</label>
      <select
        aria-labelledby="theme-widget-label"
        class="form-control"
        name="theme"
        @value="theme"
        @change="updateTheme"
      >
        <option value="nexcess">Nexcess</option>
        <option value="thermo">Thermo</option>
      </select>
      <hr />
      <div class="components-link" @click="toggle = !toggle">
        <router-link :to="{ name: 'components-alerts' }">
          <Icon icon="help" color="gamma" class="components-link-icon" :size="16" />
          Component Examples
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { useCompany, useTheme } from "@/utils";
import Icon from "@/components/display/icon/Icon";
import store from "@/store";

export default {
  name: "ThemeWidget",
  components: { Icon },
  setup() {
    const toggle = false;

    const { theme } = useTheme();
    const { company } = useCompany();

    const updateTheme = (val) => {
      store.dispatch("theme/setTheme", val.target.value);
    };

    const updateCompany = (val) => {
      store.dispatch("company/setCompany", val.target.value);
    };

    return {
      company,
      updateCompany,
      theme,
      updateTheme,
      toggle,
    };
  },
};
</script>

<style lang="scss" scoped>
.widget {
  position: fixed;
  right: 2px;
  bottom: 2px;
  width: auto;
  z-index: 1000;
  padding: 6px;
  border-radius: 3px;

  .toggle:hover {
    cursor: pointer;
  }
  .components-link {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    font-size: 0.875rem;
  }
  .components-link-icon {
    display: inline-flex;
    vertical-align: sub;
    margin-right: 5px;
  }
}
</style>
